const InvestmentsChallenge1Dataset = {
    
    items: {
        "item-1": { id: "item-1", content: "All investments are guaranteed to make money.", 
                answer: "column-1" },
        "item-2": { id: "item-2", content: "Some stocks offer dividends.", 
                answer: "column-2" },
        "item-3": { id: "item-3", content: "You should not invest money that you need for day-to-day living.",
                answer: "column-2" },
        "item-4": { id: "item-4", content: "The stock market always goes up.",
                answer: "column-1" },
        "item-5": { id: "item-5", content: "Bonds are generally considered to be a high-risk investment.", 
                answer: "column-1" },
        "item-6": { id: "item-6", content: "Stocks are considered a high-risk investment.", 
                answer: "column-2" }, 
        "item-7": { id: "item-7", content: "When you buy an Index fund you have to pay fees for the money manager.", 
                answer: "column-1" },   
        "item-8": { id: "item-8", content: "Stocks are a good investment because you can just buy them and then sit back and wait for the return.", 
                answer: "column-2" },    
        "item-9": { id: "item-9", content: "Mutual funds allow you to invest in many companies at once.",
                answer: "column-2"},
        "item-10": { id: "item-10", content: "You need to be rich to start investing.",
                answer: "column-1"}
 
    },
    columns: {
        "column-1": { id: "column-1", title: "Statements that are False", 
            itemIds: ['item-1', 'item-2', 'item-3', "item-4", "item-5", "item-6", "item-7",
                "item-8", "item-9", "item-10"
            ] },
        "column-2": { id: "column-2", title: "Statements that are True", itemIds: [] },
        
              
    },
    columnOrder: ["column-1", "column-2",]
}

export default InvestmentsChallenge1Dataset